import { useEffect, useState } from "react";

// import SignupAgreement from "../../../components/channel/signup/SignupAgreement";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Button, Form, Input } from "antd";
import ButtonGroup from "antd/es/button/button-group";
// import SignupUserInfo from "../../../components/channel/signup/SignupUserInfo";
// import SignRouteSurvey from "../../../components/channel/signup/SignupRouteSurvey";

import Swal from "sweetalert2";

import channelUserApi from "../../../apis/ChannelUser.api";
import { toastAlert } from "../../../components/AlertComponent";
import { setLoading } from "../../../redux/store/common/commonDuck";
// import {setChannelUser} from "../../../redux/store/auth/authDuck";

const FindPassword = () => {
	const history = useHistory();
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	const cUser = useSelector((state) => state.auth.channelUser);
	// const user = useSelector(state => state.auth.user);

	const dispatch = useDispatch();
	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	const [userInfo, setUserInfo] = useState({
		phone: null,
		phone_valid: null,
		password: null,
		password_valid: null,
	});
	const [smsValid, setSmsValid] = useState(false);
	const [passwordValid, setPasswordValid] = useState(true);

	const [isSendSms, setIsSendSms] = useState(false);

	useEffect(() => {
		if (cUser?.id) {
			history.goBack();
		}
	}, [cUser]);

	/**
	 * 필수 입력 항목
	 * @param e
	 */
	const handleUserInfo = (e) => {
		let { name, value } = e.target;
		let phone = value?.replaceAll(/[^0-9]/g, "");
		if (name === "phone") {
			if (phone?.length <= 11) {
				setUserInfo({
					...userInfo,
					phone: phone,
				});
			}
		} else if (name === "phone_valid") {
			if (phone?.length <= 6) {
				setUserInfo({
					...userInfo,
					[name]: phone,
				});
			}
		} else {
			setUserInfo({
				...userInfo,
				[name]: value,
			});
		}
	};

	/**
	 * step 2-1: 휴대폰 인증번호 확인
	 * @returns {Promise<void>}
	 */
	const sendPhoneValid = async () => {
		let regPhone = /010-?([0-9]{4})-?([0-9]{4})$/;
		if (regPhone.test(userInfo.phone) && reduxChannel?.nickname !== null) {
			setIsLoading(true);
			let param = {
				is_user_valid: true,
				phone: userInfo.phone,
				influencer_id: reduxChannel?.user_id,
				influencer_channel_name: reduxChannel?.nickname,
			};
			let res = await channelUserApi.findPwSendSms(param);
			console.log(res, param);
			console.log("해당 번호로 가입된 유저가 없습니다. 회원가입 하시겠습니까?");
			if (res.code === 200) {
				setIsSendSms(true);
				setIsLoading(false);
			} else {
				Swal.fire({
					customClass: "alert-custom",
					text: `해당 번호로 가입된 유저가 없습니다.\n회원가입 하시겠습니까?`,
					showCancelButton: true,
					confirmButtonText: "확인",
					cancelButtonText: "취소",
				}).then(async (result) => {
					if (result.isConfirmed) {
						history.push(
							`/together/channel/login?id=${reduxChannel?.influencer_id}`
						);
						setIsSendSms(false);
					}
				});
				setIsLoading(false);
			}
		} else {
			toastAlert("휴대폰 번호를 정확하게 입력해주세요.");
		}
	};

	/**
	 * step 2-2: 휴대폰 인증번호 일치 확인
	 */
	const checkPhoneValid = async () => {
		const regPhone = /([0-9]{6})$/;
		if (regPhone.test(userInfo.phone_valid)) {
			setIsLoading(true);

			let param = {
				phone: userInfo.phone,
				sms_verify_code: userInfo.phone_valid,
			};
			let res = await channelUserApi.sendSmsValid(param);

			if (res.code === 200) {
				Swal.fire({
					customClass: "alert-custom",
					text: "인증번호가 일치합니다.",
					confirmButtonText: "확인",
				}).then(() => {
					setSmsValid(true);
					setIsLoading(false);
				});
			} else {
				Swal.fire({
					customClass: "alert-custom",
					text: "인증번호가 일치하지 않습니다.",
					confirmButtonText: "확인",
				}).then(() => {
					setIsLoading(false);
				});
			}
		} else {
			toastAlert("휴대폰 번호를 정확하게 입력해주세요.");
		}
	};

	/**
	 * 변경 비밀번호 제출
	 */
	const handleSubmitPassword = async () => {
		if (
			!userInfo?.password?.length ||
			!userInfo?.password_valid?.length ||
			userInfo?.password !== userInfo?.password_valid
		) {
			setPasswordValid(false);
			toastAlert("비밀번호를 확인해주세요..");
		} else {
			if (userInfo?.password?.length < 8) {
				toastAlert("8자리 이상 비밀번호를 입력해주세요.");
			} else {
				if (userInfo?.password !== userInfo?.password_valid) {
					toastAlert("비밀번호를 확인해주세요.");
				} else {
					setIsLoading(true);
					setPasswordValid(true);
					const param = {
						...userInfo,
					};
					const res = await channelUserApi.postFindPw(param);
					if (res.code === 200) {
						Swal.fire({
							customClass: "alert-custom",
							text: "성공적으로 비밀번호가 변경되었습니다.",
							confirmButtonText: "확인",
						}).then(() => {
							const backPage = sessionStorage.getItem("backPage");
							// console.log(backPage);
							if (backPage) {
								history.replace(backPage);
								sessionStorage.removeItem("backPage");
							} else {
								history.replace(
									`/together/channel/login?id=${reduxChannel?.influencer_id}`
								);
							}
						});
					} else {
						Swal.fire({
							customClass: "alert-custom",
							text: "오류가 발생했습니다. 잠시 후 다시 시도해주세요.",
							confirmButtonText: "확인",
						}).then(() => {});
					}
					setIsLoading(false);
				}
			}
		}
	};

	return (
		<div className={`channel-wrap channel-home channel-delay`}>
			<div className={`home-body home-each`}>
				<div className={`max-width-apply`}>
					<div className={`home-recommend-horizontal sign-up-div`}>
						<div className={`recommend-title`}>
							<p className={`title`}>비밀번호 찾기</p>
						</div>
						<div className={`signup-body`}>
							{!smsValid ? (
								<p className={`signup-sub-title signup-border`}>
									가입한 휴대폰 번호 정보를 입력해주세요
								</p>
							) : (
								<p className={`signup-sub-title signup-border`}>
									새로운 비밀번호를 입력해주세요
								</p>
							)}
							{!smsValid ? (
								<Form layout={`vertical`} className={`signup-userInfo-div`}>
									<Form.Item
										label="휴대폰 인증"
										labelAlign="left"
										colon={false}
									>
										<Input
											type={`text`}
											name={`phone`}
											placeholder={`휴대폰 번호를 입력해주세요`}
											value={userInfo.phone}
											pattern="\d*"
											onChange={handleUserInfo}
											onPressEnter={sendPhoneValid}
											disabled={isSendSms}
										/>
										{!isSendSms && (
											<Button
												className={`button-width-full`}
												onClick={sendPhoneValid}
												loading={isLoading}
											>
												인증 요청
											</Button>
										)}
									</Form.Item>
									{!!isSendSms && (
										<Form.Item
											label="휴대폰 인증번호"
											labelAlign="left"
											colon={false}
										>
											<Input
												type={`text`}
												name={`phone_valid`}
												placeholder={`인증번호 6자리를 입력해주세요`}
												value={userInfo.phone_valid}
												pattern="\d*"
												onChange={handleUserInfo}
												onPressEnter={checkPhoneValid}
												disabled={smsValid}
											/>
											{smsValid ? (
												<Button
													className={`button-width-full finish-gray`}
													disabled={true}
												>
													인증 완료
												</Button>
											) : (
												<Button
													className={`button-width-full`}
													onClick={checkPhoneValid}
													loading={isLoading}
													disabled={
														!userInfo.phone_valid ||
														userInfo.phone_valid?.length < 6
													}
												>
													인증번호 확인
												</Button>
											)}
										</Form.Item>
									)}
								</Form>
							) : (
								<Form layout={`vertical`} className={`signup-userInfo-div`}>
									<Form.Item
										label="변경 비밀번호"
										labelAlign="left"
										colon={false}
									>
										<Input
											type={`password`}
											name={`password`}
											placeholder={`8자리 이상 비밀번호를 입력해주세요.`}
											value={userInfo.password}
											onChange={handleUserInfo}
											disabled={!smsValid}
										/>
									</Form.Item>
									<Form.Item
										label="변경 비밀번호 확인"
										labelAlign="left"
										colon={false}
									>
										<Input
											type={`password`}
											name={`password_valid`}
											placeholder={`8자리 이상 비밀번호를 입력해주세요.`}
											value={userInfo.password_valid}
											onChange={handleUserInfo}
											disabled={!smsValid}
										/>
										{!!userInfo.password_valid?.length && smsValid && (
											<>
												{!passwordValid && (
													<p className={`caution`}>*비밀번호를 확인해주세요</p>
												)}
											</>
										)}
									</Form.Item>
								</Form>
							)}
						</div>

						{smsValid && (
							<div className={`signup-footer`}>
								<ButtonGroup>
									<Button
										className={`black-button`}
										style={{ width: "100%" }}
										onClick={handleSubmitPassword}
										loading={isLoading}
									>
										변경하기
									</Button>
								</ButtonGroup>
							</div>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};
export default FindPassword;
